const blendStyle = (...styles) => {
    return Object.assign({}, ...styles)
}

export default blendStyle



// WEBPACK FOOTER //
// ./src/blendStyle.js